import React, { memo, useContext, useEffect } from 'react'
import tw from 'twin.macro'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { OnboardingsContext } from '../onboardings/Onboardings.context'
import { OnboardingsTableContext } from '../onboardings-table/OnboardingsTable.context'
import { ColumnHiddenTooltip } from 'src/components/shared/ColumnHiddenTooltip'

const TAGS_FIELD = 'tags'

const OnboardingTagsSelectComponent = () => {
  const { tagsFilter, setTagsFilter } = useContext(OnboardingsContext)
  const { columnVisibilityModel } = useContext(OnboardingsTableContext)

  const isColumnHidden = columnVisibilityModel[TAGS_FIELD] === false

  useEffect(() => {
    if (isColumnHidden && tagsFilter.length) {
      setTagsFilter([])
    }
  }, [isColumnHidden, tagsFilter, setTagsFilter])

  return (
    <ColumnHiddenTooltip disabled={isColumnHidden} columnName="Tag(s)">
      <div
        aria-disabled={isColumnHidden}
        css={isColumnHidden && tw`pointer-events-none opacity-50`}
      >
        <TableTagsSelect
          selectedTags={tagsFilter}
          setSelectedTags={setTagsFilter}
          triggerDataTestId="contractors-onboarding-list-tags-menu-btn"
          clearAllDataTestId="contractors-onboarding-list-tags-clear-all"
          manageOptionsDataTestId="contractors-onboarding-list-tags-manage-options"
        />
      </div>
    </ColumnHiddenTooltip>
  )
}

export const OnboardingTagsSelect = memo(OnboardingTagsSelectComponent)
